(() => {
  const parallaxEls = document.querySelectorAll('[data-parallax]');
  const scaleEls = document.querySelectorAll('[data-scale]');

  if (!parallaxEls.length && !scaleEls.length) return;

  let ticking = false;

  const update = () => {
    const vh = window.innerHeight;

    parallaxEls.forEach(el => {
      const r = el.getBoundingClientRect();
      const t = (r.top - vh) / (vh + r.height);
      const strength = parseFloat(el.dataset.parallax || '24'); // px
      el.style.setProperty('--y', `${(-t * strength).toFixed(2)}px`);
    });

    scaleEls.forEach(el => {
      const r = el.getBoundingClientRect();
      const progress = 1 - Math.min(1, Math.max(0, r.top / vh)); // 0..1
      const min = parseFloat(el.dataset.scaleMin || '0.96');
      const max = parseFloat(el.dataset.scaleMax || '1.00');
      const s = (min + (max - min) * progress).toFixed(3);
      el.style.setProperty('--s', s);
    });

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();